// Module
var code = `<!-- §2 THE CORE — RATIFIED-WD v10 (copy of record 2026-08-13; audit fixes 2026-08-16: #6 payoff line, #9 lossless→complete; payoff C1 pending final confirm) -->
<section class="core-section" aria-labelledby="core-headline">

    <div class="core-section__inner">

        <header class="core-section__header">
            <h2 id="core-headline" class="core-section__headline landing-headline"><span class="landing-eyebrow">THE FRAMEWORK</span>
                A complete structural language for developers and agents.
            </h2>
            <p class="core-section__lead">Display and behavior are declared and wired together to define what the application does, and kept separate from content. Every agent, every session, every model reads the same complete definition.

            </p>
            <p class="core-section__payoff">
                The codebase becomes the spec — it evolves with every change, and developers and agents can read it at the source.
            </p>
        </header>

        <div class="core-section__access">
            <h3 class="core-section__subhead">
                Works with the AI models you already use.
            </h3>




            <p class="core-section__kit">

                Every SpyneJS template ships with <strong>generative grammar</strong>. A model's knowledge of the web — HTML, CSS, JavaScript, and the specifications behind them — is applied directly to a rules-based structure, removing the noise from generated code. Content remains fully expressive.
            </p>

            <div class="core-section__play">
                <code class="core-section__cmd">npx spyne-cli create-app</code>
                <span class="core-section__play-note">&mdash; then <code class="core-section__play-cmd">npm start</code>. Same workflow, same tools.</span>
            </div>
<!--            <p class="core-section__kicker">
                The language has a spine: <strong>VBL</strong>.
            </p>-->
        </div>



    </div>

</section>
`;
// Exports
module.exports = code;